export default __webpack_public_path__ + "ca90a9f65fd3cb77666debabcb39af82.png";